'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
var ReactDOM = _interopDefault(require('react-dom'));
var reactRouter = require('react-router');
require('./_index.scss.js');

var CLASSNAME = 'varta-toast',
    cnIn = "".concat(CLASSNAME, "--in"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnSubline = "".concat(CLASSNAME, "__subline"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnClose = "".concat(CLASSNAME, "__close");
/**
 * 
 */

var Toast = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Toast, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Toast);

  function Toast() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Toast);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      slidedOut: true
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onRouteChangeStart", function () {
      _this.onClose();
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onClose", function (e) {
      if (e) {
        e.stopPropagation();
      }

      var onClose = _this.props.onClose;
      onClose();
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onTransitionEnd", function () {
      var open = _this.props.open;

      _this.setState({
        slidedOut: !open
      });
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Toast, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.unlisten = reactRouter.browserHistory === null || reactRouter.browserHistory === void 0 ? void 0 : reactRouter.browserHistory.listen(function (location) {
        _this2.onRouteChangeStart.bind(_this2);
      });

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      var _this$props = this.props,
          open = _this$props.open,
          delay = _this$props.delay;

      if (delay && open && !this.timeout) {
        this.timeout = setTimeout(function () {
          _this2.onClose();

          _this2.timeout = null;
        }, delay);
      } // re-render after portal is available
      // @see https://github.com/zeit/next.js/blob/canary/examples/with-portals/components/Portal.js#L7


      this.forceUpdate();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      this.unlisten = reactRouter.browserHistory === null || reactRouter.browserHistory === void 0 ? void 0 : reactRouter.browserHistory.listen(function (location) {
        _this3.onRouteChangeStart.bind(_this3);
      });

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this4 = this;

      var _this$props2 = this.props,
          open = _this$props2.open,
          delay = _this$props2.delay;
      var slideIn = this.state.slideIn;

      if (open && !slideIn) {
        setTimeout(function () {
          _this4.setState({
            slideIn: true,
            slidedOut: false
          });
        }, 32);
      }

      if (delay && open && !this.timeout) {
        this.timeout = setTimeout(function () {
          _this4.onClose();

          _this4.timeout = null;
        }, delay);
      } else if (!open && this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props3 = this.props,
          open = _this$props3.open,
          title = _this$props3.title,
          subline = _this$props3.subline,
          className = _this$props3.className,
          button = _this$props3.button,
          showCloseButton = _this$props3.showCloseButton,
          type = _this$props3.type;
      var _this$state = this.state,
          slideIn = _this$state.slideIn,
          slidedOut = _this$state.slidedOut;

      if (!open && slidedOut || typeof document === 'undefined') {
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
      }

      var portal = document.querySelector('#toastPortal');

      if (!portal) {
        console.warn('Couldn\'t find element with ID `toastPortal`');
        return /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
      }

      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME, className, "".concat(CLASSNAME, "--").concat(type), _rollupPluginBabelHelpers.defineProperty({}, cnIn, slideIn)),
        onTransitionEnd: this.onTransitionEnd
      }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement("b", {
        className: cnTitle
      }, title), /*#__PURE__*/React__default.createElement("span", {
        className: cnSubline
      }, subline)), button && button.onClick && /*#__PURE__*/React__default.createElement("a", {
        href: "#",
        className: cnButton,
        onClick: function onClick(e) {
          e.preventDefault();
          button.onClick(e);

          _this5.onClose(e);
        }
      }, button.title), button && button.link && /*#__PURE__*/React__default.createElement(Link, {
        link: button.link,
        className: cnButton
      }, button.title), showCloseButton && /*#__PURE__*/React__default.createElement("button", {
        onClick: this.onClose,
        className: cnClose
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "times",
        size: "xs"
      }), /*#__PURE__*/React__default.createElement(MaterialDrop, null))), portal);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      var open = props.open;

      if (!open) {
        return {
          slideIn: open
        };
      }

      return null;
    }
  }]);

  return Toast;
}(React__default.Component);
Toast.propTypes = {
  /** Button object */
  button: PropTypes.shape({
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    link: PropTypes.string
  }),

  /** Additional class name */
  className: PropTypes.string,

  /** ms until Toast disappers */
  delay: PropTypes.number,

  /** Callback function */
  onClose: PropTypes.func,

  /** True to display Toast */
  open: PropTypes.bool,

  /** True for x to close */
  showCloseButton: PropTypes.bool,

  /** Subtitle */
  subline: PropTypes.string,

  /** Title */
  title: PropTypes.string,

  /** Type defines background color */
  type: PropTypes.oneOf(['error', 'warning', 'success'])
};
Toast.defaultProps = {
  onClose: function onClose() {
    return void 0;
  },
  showCloseButton: true,
  delay: 0,
  type: 'error'
};

module.exports = Toast;
